/* Mobile Navi */
const naviControl = () => {
	btn = document.querySelector('#btn-menu');
	nav = document.querySelector('nav');
	shutter = document.querySelector('#abblender');

	if (btn.classList.contains('active')) {
		nav.classList.remove('hidden');
		shutter.style.display = 'block';
	} else {
		shutter.style.display = 'none';
		nav.classList.add('hidden');
	}
}


/* Click Events */
document.addEventListener('click', (e) => {
	if (e.target.id == 'btn-menu') {
		btn = document.querySelector('#btn-menu');
		btn.classList.toggle('active')
		naviControl();
	}

	if (e.target.id == 'shutter') {
		btn = document.querySelector('#btn-menu');
		btn.classList.remove('active')
		naviControl();
	}

	if (e.target.id == 'cookie-confirm') {
		document.cookie = 'cookieConsent=true; expires=Thu, 18 Dec 2099 12:00:00 UTC;path=/';
		location.reload();
	}
})

/* On Load */
document.addEventListener('DOMContentLoaded', () => {
	const body = document.body;
	const header = document.querySelector('header');

	document.querySelector('.header-menu-button').addEventListener('click', (e) => {
		e.target.classList.toggle('active')

		if (!header.classList.contains('nav-is-open')) {
			e.target.querySelector('span').innerText = 'Schließen';
			body.style.overflow = 'hidden'
		} else {
			e.target.querySelector('span').innerText = 'Menü';
			body.style.overflow = null
		}

		header.classList.toggle('nav-is-open');
	})

	document.querySelectorAll('.block__slider').forEach((el) => {
		const slider = el;
		const sliderInner = slider.querySelector('.block__slider__inner');
		let translateX = 0;

		slider.querySelector('.block__slider__controls').addEventListener('click', (e) => {
			let activeItem = slider.querySelector('.active');

			let sliderOffset = slider.getBoundingClientRect().left;

			let moveOffset;

			if (e.target.className === 'controls-prev') {
				const prevItem = activeItem.previousElementSibling;
				// moveOffset = prevItem.getBoundingClientRect().left;
				moveOffset = prevItem.offsetLeft;
				// activeItem.classList.remove('active');
				// prevItem.classList.add('active');


				/* if (prevItem.nextElementSibling) {
					slider.querySelector('.controls-next').disabled = false;
				}
				
				if (!prevItem.previousElementSibling) {
					e.target.disabled = true;
				} */

			} else if (e.target.className === 'controls-next') {
				const nextItem = activeItem.nextElementSibling;
				// moveOffset = nextItem.getBoundingClientRect().left;
				moveOffset = nextItem.offsetLeft;
				// activeItem.classList.remove('active');
				// nextItem.classList.add('active');

				/* if (nextItem.previousElementSibling) {
					slider.querySelector('.controls-prev').disabled = false;
				}
				
				if (!nextItem.nextElementSibling) {
					e.target.disabled = true;
				} */
			}
			// Transform Method
			// translateX += sliderOffset - moveOffset;
			// sliderInner.style.transform = 'translate3d(' + translateX + 'px,0, 0)'

			// ScrollLeft Method
			// sliderInner.scrollLeft = moveOffset;

			sliderInner.scrollTo({
				top: 0,
				left: moveOffset,
				behavior: 'smooth'
			});
		})

		sliderInner.addEventListener('scroll', (e) => {
			const sliderOffset = slider.offsetLeft;
			let childrenItem = sliderInner.querySelectorAll('.card');

			childrenItem.forEach(el => {
				const activeItem = slider.querySelector('.active');
				const offsetLeft = el.getBoundingClientRect().left;
				if (offsetLeft > (sliderOffset - 2) && offsetLeft < (sliderOffset + 2)) {
					activeItem.classList.remove('active');
					el.classList.add('active');

					if (el.nextElementSibling) {
						slider.querySelector('.controls-next').disabled = false;
					} else {
						slider.querySelector('.controls-next').disabled = true
					}
					if (!el.nextElementSibling) {
					}

					if (el.previousElementSibling) {
						slider.querySelector('.controls-prev').disabled = false;
					} else {
						slider.querySelector('.controls-prev').disabled = true;
					}


					if (!el.previousElementSibling) {
					}
				}

				// console.log('Offset: ' + offsetLeft)

			})


			if (e.target.scrollLeft % e.target.offsetWidth === 0) {
				// console.log('Scrolling is done!');
			}
		})
	})

	if (document.body.classList.contains("single-references")) {
		const bannerTitle = document.querySelector(".banner__title");

		const root = document.querySelector(":root");
		bannerTitle?.querySelectorAll('span').forEach((el, index) => {
			if (index == 0 && el.offsetLeft > 0) {return;}
			if (index == 1 && el.offsetLeft + el.clientWidth < document.documentElement.clientWidth) {return;}


			let value = getComputedStyle(root).getPropertyValue("--h1-font-size");

			let dir;
			let offset;
			if (el.offsetLeft < 0) {
				dir = "left";
				offset = el.offsetLeft;
			} else if (el.offsetLeft + el.clientWidth > document.documentElement.clientWidth) {
				dir = "right";
				offset = el.offsetLeft + el.clientWidth;
			}

			const startIndex = value.indexOf("(") + 1;
			const endIndex = value.indexOf("/") - 1;
			const calcExpr = value.substring(startIndex);
			const calcExprParts = calcExpr.split(" ");
			const calcExprValue = calcExprParts[2].replace("(", "");
			const resolution = calcExprParts[4].replace("))", "");
			let num = parseInt(calcExprValue);

			let counter = 0;
			const limiter = 400; // maximum number of iterations allowed
			if (dir == "left") {
				while (offset < 0 && counter < limiter) {
					num -= 1; // reduce num by 1

					// concatenate the updated value string
					value = `calc(100vw * (${num} / ${resolution}))`;

					bannerTitle.style.fontSize = value; // set the new value as the CSS style

					counter++;
					offset = el.offsetLeft
				}
			} else if (dir == "right") {
				while (offset > document.documentElement.clientWidth && counter < limiter) {
					num -= 1; // reduce num by 1

					// concatenate the updated value string
					value = `calc(100vw * (${num} / ${resolution}))`;

					bannerTitle.style.fontSize = value; // set the new value as the CSS style

					counter++;
					offset = el.offsetLeft + el.clientWidth;
				}
			}
			
			if (counter >= limiter) {
				console.log("Exceeded maximum number of iterations!");
			}
		});
	}
})